var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceDataTopRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 545,
    height: 714,
    viewBox: "0 0 545 714",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M177.469 102.43L188.726 121.145L238.719 204.291L299.968 102.43H177.469Z",
    fill: "#00CC8F"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-6.31648e-05 182.7H96.5268L96.5337 182.691L48.2737 102.43H48.2599L-6.31648e-05 182.691V182.7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M361.231 204.301L299.982 102.44H299.968L238.719 204.301L238.726 204.31H361.225L361.231 204.301Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.485 101.46L117.118 1.07271H237.848L177.485 101.46Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M483.737 408.058L483.744 408.049L422.494 306.188H422.481L361.231 408.049L361.238 408.058H483.737Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M299.982 306.187L361.231 408.048L422.48 306.187H299.982Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M422.487 306.172L361.238 204.311H361.224L299.975 306.172L299.982 306.19H422.48L422.487 306.172Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M361.231 611.79L422.487 509.929H299.982L361.231 611.79Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M422.494 509.926H422.487L361.231 611.787L361.238 611.796H483.744V611.787L422.494 509.926Z",
    fill: "white",
    fillOpacity: 0.3
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M422.487 713.658L483.744 611.797H361.238L422.487 713.658Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M422.487 103.399L482.865 203.81H362.11L422.487 103.399Z",
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M422.494 306.179H544.993L545 306.17L483.751 204.309H483.737H361.238L422.487 306.17L422.494 306.179Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M362.122 408.556H483.468L544.121 509.426H422.776L362.122 408.556Z",
    stroke: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M238.732 0.57271H238.725H238.732L299.975 102.434L361.224 0.57271H238.746H238.732Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M299.982 509.926H299.975L238.719 611.787L238.726 611.796H361.231V611.787L299.982 509.926Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116.206 203.329L55.8408 102.938H176.572L159.929 130.628L159.929 130.628L116.206 203.329Z",
    stroke: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M160.786 131.145L177.377 103.541L177.386 103.563L177.477 103.412L188.298 121.413L188.668 121.19L188.298 121.413L238.134 204.3L177.462 305.201L116.79 204.3L160.786 131.146L160.362 130.89L160.786 131.145ZM178.362 101.94L238.732 1.54083L299.096 101.94H178.362ZM361.231 203.331L300.559 102.43L361.507 1.07053H482.853L422.199 101.94H422.198L422.052 102.183L361.231 203.331Z",
    stroke: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M238.719 205.27L299.102 305.69H178.336L238.719 205.27Z",
    stroke: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M361.238 204.31L361.231 204.301L361.225 204.31H361.238Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M212.746 424.099L192.348 458.021L171.944 424.099H212.746Z",
    stroke: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M308.486 633.918L275.948 688.028L243.41 633.918H308.486Z",
    stroke: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M238.719 611.796H238.726L238.719 611.787V611.796Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9497 102.43L54.9428 102.439H54.9565L54.9497 102.43Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M116.199 204.31H116.213L116.206 204.301L116.199 204.31Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M361.232 611.796H361.238L361.232 611.787V611.796Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M177.456 306.19H177.469L177.462 306.173L177.456 306.19Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M360.353 407.558H239.598L299.975 307.147L360.353 407.558Z",
    stroke: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M300.866 509.426L361.238 409.026L421.609 509.426H300.866Z",
    stroke: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M299.982 509.926L361.238 408.056H238.698L299.982 509.926Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M361.258 0.563864H361.245L300.002 102.407L300.009 102.425L300.002 102.434H422.501L422.508 102.425L361.258 0.563864Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M238.719 0.563864H238.698L177.463 102.407L177.469 102.425L177.463 102.434H299.955L299.961 102.425L238.719 0.563864Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M299.982 509.926L238.712 611.761L238.725 611.778L238.718 611.796H361.21L361.217 611.778L299.982 509.926Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M422.795 305.985H422.782L361.539 407.828L361.546 407.846L361.539 407.864H484.038L484.045 407.846L422.795 305.985Z",
    fill: "#00CC8F"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M116.234 204.318L127.491 223.033L177.483 306.179L238.732 204.318H116.234Z",
    fill: "#00CC8F"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M133.311 175.862L116.206 204.31H238.705L177.456 102.449L133.311 175.862Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M219.868 419.31L256.638 358.162V358.153H256.631H183.098L219.868 419.31Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M422.145 102.493L360.916 0.667549H422.145V102.493Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceDataTopRight);
export default __webpack_public_path__ + "static/media/serviceDataTopRight.5cebe85b6d8a6cf3f8ce809723353779.svg";
export { ForwardRef as ReactComponent };